/**
 * Форма генерации документов
 */

import React from 'react';
import { Formik, Form, Field } from 'formik';
import { TextInput, Select } from '@components/UI/FormItems';
import { useDocumentTypes, useGenerateDocument } from '@/hooks/useAdmin.ts';
import { generateDocumentSchema } from '../validation/schemas';
import type { DocumentGenerationParams } from '@types';

interface GenerateDocumentFormValues {
  applicationId: string;
  genDate: string;
  tosave: boolean;
  sendToMyMfo: boolean;
}

/**
 * Компонент формы генерации документов
 */
export const GenerateDocumentFormComponent: React.FC = () => {
  const generateDocumentMutation = useGenerateDocument();
  const { data: docTypes = [] } = useDocumentTypes();
  const [selectedDocType, setSelectedDocType] = React.useState<number>(0);

  const initialValues: GenerateDocumentFormValues = {
    applicationId: '',
    genDate: '',
    tosave: false,
    sendToMyMfo: false,
  };

  const handleSubmit = async (values: GenerateDocumentFormValues, { resetForm }: { resetForm: () => void }) => {
    const id = Number(values.applicationId);
    if (!id || !selectedDocType) return;

    const params: DocumentGenerationParams = {
      applicationId: id,
      genDate: values.genDate,
      tosave: values.tosave,
      sendToMyMfo: values.sendToMyMfo,
      docType: selectedDocType,
    };

    await generateDocumentMutation.mutateAsync(params);
    resetForm();
    setSelectedDocType(0);
  };

  return (
    <fieldset>
      <Formik
        initialValues={initialValues}
        validationSchema={generateDocumentSchema}
        onSubmit={handleSubmit}
      >
        {() => (
          <Form>
            <div style={{ display: 'table' }}>
              <div style={{ marginLeft: '10px', fontWeight: 'bold' }}>
                Генерация документов по id заявки
              </div>
              <br />

              <TextInput
                label="id Заявки : "
                name="applicationId"
                placeholder="123456"
                style={{ width: '120px' }}
              />
              <br />

              <TextInput
                label="Дата генерации : "
                type="date"
                name="genDate"
              />
              <br />

              <div>
                <Select
                  label="Тип документа"
                  name="docType"
                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setSelectedDocType(parseInt(e.target.value, 10))}
                >
                  <option value={0}>Не выбран</option>
                  {docTypes.map((doc) => (
                    <option key={doc.id} value={doc.id}>
                      {doc.name}
                    </option>
                  ))}
                </Select>
              </div>
              <br />

              <div>
                <label>
                  <Field type="checkbox" name="tosave" />
                  Генерация с сохранением и обновлением пакета
                </label>
              </div>
              <br />

              <div>
                <label>
                  <Field type="checkbox" name="sendToMyMfo" />
                  Отправить полученный пакет документов в 1с
                </label>
              </div>

              <button
                className="btn"
                type="submit"
                disabled={generateDocumentMutation.isPending}
                style={{ marginTop: '20px' }}
              >
                {generateDocumentMutation.isPending ? 'Генерация...' : 'Сгенерировать'}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </fieldset>
  );
};
